import { render, staticRenderFns } from "./drawMark.vue?vue&type=template&id=edc1a9c8&scoped=true"
import script from "./drawMark.vue?vue&type=script&lang=js"
export * from "./drawMark.vue?vue&type=script&lang=js"
import style0 from "./drawMark.vue?vue&type=style&index=0&id=edc1a9c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc1a9c8",
  null
  
)

export default component.exports